import loadable from '@loadable/component';
const DrawMetaTags = loadable(
    () => import(/*webpackChunkName: "pkg_____common"*/ "./metatags")
);

export default DrawMetaTags